import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Account } from "../../services/accounts.service";

export interface AccountsState {
  accounts: Account[];
}

const initialState: AccountsState = {
  accounts: [],
};

const accountsSlice = createSlice({
  name: "accounts",
  initialState,
  reducers: {
    setAccounts(state, action: PayloadAction<Account[]>) {
      state.accounts = action.payload;
    },
    clearAccounts(state) {
      state.accounts = [];
    },
  },
});

export const { setAccounts, clearAccounts } = accountsSlice.actions;
export default accountsSlice.reducer;